import styled from 'styled-components';

export const ContainerLoader = styled.div`
  width: 100%;
  height: 75px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ContainerFlex = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 150px;
`;
